module.exports = __webpack_public_path__ + "static/media/own-wizard-icon.5c4f1d0a.svg";